const localStorageConstants = {
  ACCESS_TOKEN: '@SPOTIVUE:at',
  VOLUME_USER: '@SPOTIVUE:volume',
}

export default localStorageConstants